import { IRestfulConfigMap } from "@core/data-access/restful";
import { appConfig } from "@env/app-config";
import { envConfig } from "@env/env-config";

let WebSiteCurrencyServiceConfig: IRestfulConfigMap = {
    webSiteCurrencyRestService: {
        appPath: envConfig.appPath("base"),
        isAuth: true,
        actions: {
            // 获取网站支持的货币列表
            getAll: {
                method: "get",
                path: "api/platform/currencies",
                testPath: "api/platform/currencies",
                isAuth: true,
                requestConfig: {
                    headers: {
                        platform: appConfig.websiteCode
                    }
                }
            },
            // 
            // verify: {
            //     method: "get",
            //     path: "api/users/preference/currency",
            //     testPath: "api/users/preference/currency",
            //     isAuth: true,
            //     requestConfig: {
            //         headers: {
            //             platform: appConfig.websiteCode
            //         }
            //     },
            //     paramDefaults: {
            //         inputCurrencyCode: "@currencyCode"
            //     }
            // }
        },
    },
};

export { WebSiteCurrencyServiceConfig };
